import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from '../ui/common';
import warrantyIcon from './icons/warranty.svg';
import boxIcon from './icons/box.svg';
import warrantyIconBlue from './icons/warrantyBlue.svg';
import boxIconBlue from './icons/boxBlue.svg';
import Option from './Option';

const Row = styled.div`
  ${media.phone`
    display: flex;
    margin: 0 -16px;
  `}
`;

export default function OptionsList({ color }) {
  return (
    <Row>
      {color === 'blue' && (
        <>
          <Option
            src={warrantyIconBlue}
            alt=""
            text="product.options.warranty"
          />
          <Option src={boxIconBlue} alt="" text="product.options.shipping" />
        </>
      )}
      {color !== 'blue' && (
        <>
          <Option src={warrantyIcon} alt="" text="product.options.warranty" />
          <Option src={boxIcon} alt="" text="product.options.shipping" />
        </>
      )}
    </Row>
  );
}

OptionsList.propTypes = {
  color: PropTypes.string.isRequired,
};
